import { createSlice } from '@reduxjs/toolkit';

import socket from '../../utils/socket';

const initialState = {
  isLoading: false,
  error: false,
  // datas
  profile: {}
};

const slice = createSlice({
  name: 'profiles',
  initialState,
  reducers: {
    // LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
      console.error(state.error);
    },

    getProfile(state, action) {
      const { profiles } = action.payload;
      state.isLoading = false;
      state.profile = profiles;
    }
  }
});

// Reducer
export default slice.reducer;

export function getProfile(profileId) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const result = await socket.get('/profiles', {
        profileId
      });
      dispatch(slice.actions.getProfile(result));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
